var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 24 24",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 18.389V9.55556C3 9.03995 3.11106 8.55457 3.33319 8.09942C3.55551 7.64428 3.87959 7.25006 4.30545 6.91677L9.97226 2.66667C10.5833 2.22222 11.2406 2 11.9444 2C12.6481 2 13.3055 2.22222 13.9165 2.66667L19.5833 6.91677C20.0092 7.25006 20.3332 7.64428 20.5556 8.09942C20.7777 8.55457 20.8887 9.03995 20.8887 9.55556V18.389C20.8887 19.401 20.54 20.2559 19.8424 20.9537C19.1447 21.6512 18.2898 22 17.2777 22H15.8055C15.3554 22 14.9698 21.8394 14.6485 21.5181C14.3272 21.1968 14.1666 20.8112 14.1666 20.3611V15.139C14.1666 14.6889 14.0061 14.3032 13.6853 13.982C13.3645 13.6607 12.9795 13.5001 12.5302 13.5001H11.3684C10.9191 13.5001 10.5324 13.6607 10.2083 13.982C9.88419 14.3032 9.72215 14.6889 9.72215 15.139V20.3611C9.72215 20.8112 9.56152 21.1968 9.24025 21.5181C8.91898 21.8394 8.53331 22 8.08323 22H6.61104C5.59898 22 4.74407 21.6512 4.04633 20.9537C3.34878 20.2559 3 19.401 3 18.389Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeDefault);
export default __webpack_public_path__ + "static/media/home-default.84ed752cbcf7da6fdc201730653ca04d.svg";
export { ForwardRef as ReactComponent };